import * as React from 'react';
import { useEffect, useState } from 'react';

import {
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useTheme,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';

import { CloseModalIconButton } from '@/components/IconButton/close-modal';

interface IWrongCountryModal {
  isOpen: boolean;
  onClose(): void;
}

/**
 * Modal component for resend verification link
 * @component
 * @param    {IWrongCountryModal}   props     Component props
 * @param    {boolean}  props.isOpen  Modal open or not
 * @param    {void}  props.onClose  Function to close modal
 * @example
 * <WrongCountryModal
 *    isOpen={isOpen}
 *    onClose={onClose}
 * />
 */
export const WrongCountryModal: React.FC<IWrongCountryModal> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false);
      }, 30000);
    }
  }, [isDisabled]);

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      size='2xl'
    >
      <ModalOverlay />

      <ModalContent>
        <CloseModalIconButton onClick={onClose} />

        <ModalBody pb='1.875rem' pt='lg' px='lg'>
          <Flex align='center' justify='center'>
            <FiAlertTriangle color={theme.colors.app.pink} size='3.75rem' />
          </Flex>

          <Heading
            as='h3'
            colorScheme='app.pink'
            fontSize='3xl'
            my='lg'
            textAlign='center'
          >
            {t('errorCode.1106')}
          </Heading>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
